module.exports = {"ORDER_WITHOUT_ACCOUNT":"Wil je bestellen zonder account?","EMAIL":"E-mailadres","SUBMIT":"GA VERDER ZONDER ACCOUNT"}


//////////////////
// WEBPACK FOOTER
// ./src/plugins/tfs/platformConfigs/staticTextMaps/guest.json
// module id = 1665
// module chunks = 1